import type {
  AuthResponse,
  ChangePasswordCredentials,
  LoginCredentials,
  RegisterCredentials,
  resetPasswordCredentials,
} from "../../../types/auth";
import apiClient from "../config";

// API calls
export const loginUser = async (
  credentials: LoginCredentials
): Promise<AuthResponse> => {
  const { data } = await apiClient.post<AuthResponse>(
    "/student/authenticate",
    credentials
  );
  return data;
};

export const registerAndEnrollUser = async (
  credentials: RegisterCredentials,
  courseId: number
) => {
  const { data } = await apiClient.post(
    `/student/createStudentAndCourse/${courseId}/0`,
    credentials
  );
  return data;
};

export const registerUser = async (credentials: RegisterCredentials) => {
  const { data } = await apiClient.post("/student/createStudent", credentials);
  return data;
};

export const changePassword = async (
  credentials: ChangePasswordCredentials
) => {
  const { data } = await apiClient.put(
    "/student/studentChangePassword",
    credentials
  );
  return data;
};

// Email-only password reset
export const resetPassword = async (credentials: resetPasswordCredentials) => {
  const { data } = await apiClient.put(
    "/student/resetStudentPassword",
    credentials
  );
  return data;
};

// Email + DOB password reset (returns new password)
export const resetPasswordWithYearOfBirth = async (
  credentials: resetPasswordCredentials
) => {
  const { data } = await apiClient.put(
    "/student/resetStudentPasswordWithYearOfBirth",
    credentials
  );
  return data;
};
